import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { jobCandidatesLoad } from '@modules/job-page/store';
import { map, withLatestFrom } from 'rxjs/operators';
import { getJobsSelectedId } from '@collections/jobs';
import { getJobPageFilter } from '@modules/job-page/store/matched-candidates-filter';
import {
  trackAssociateCandidates,
  trackFeedbackCreate,
  trackLoadCandidates,
  trackLoadJobCandidates,
  trackViewCandidateDetails,
} from '@core/activity-tracking/activity-tracking.actions';
import { candidatesLoad } from '@modules/candidates/store';
import { feedbackCreate } from '@collections/feedback';
import { candidatesSelect } from '@collections/candidates';
import { associateCandidates } from '@modules/assigns/store';

@Injectable()
export class ActivityTrackingEffects {
  loadJobMatches$ = createEffect(() =>
    this.actions$.pipe(
      ofType(jobCandidatesLoad),
      withLatestFrom(this.store.select(getJobsSelectedId), this.store.select(getJobPageFilter)),
      map(([{ params }, jobId, filters]) =>
        trackLoadJobCandidates({
          payload: {
            jobId,
            params,
            category: filters?.category,
          },
        }),
      ),
    ),
  );

  loadCandidates$ = createEffect(() =>
    this.actions$.pipe(
      ofType(candidatesLoad),
      map(({ payload }) => trackLoadCandidates({ payload })),
    ),
  );

  createFeedback$ = createEffect(() =>
    this.actions$.pipe(
      ofType(feedbackCreate),
      withLatestFrom(this.store.select(getJobsSelectedId)),
      map(([{ feedback }, jobId]) =>
        trackFeedbackCreate({
          payload: {
            jobId,
            candidateId: feedback?.candidateId,
            feedbackType: feedback?.type,
            feedbackValue: feedback?.value,
          },
        }),
      ),
    ),
  );

  candidateView$ = createEffect(() =>
    this.actions$.pipe(
      ofType(candidatesSelect),
      map(({ id }) =>
        trackViewCandidateDetails({
          payload: { candidateId: id, viewContext: 'NON_PROJECT' },
        }),
      ),
    ),
  );

  associateCandidate$ = createEffect(() =>
    this.actions$.pipe(
      ofType(associateCandidates),
      withLatestFrom(this.store.select(getJobsSelectedId)),
      map(([{ associations }, jobId]) => {
        const candidateIds = associations.map((a) => a.candidateId);
        return trackAssociateCandidates({ payload: { candidateIds, associations, jobId } });
      }),
    ),
  );

  constructor(private actions$: Actions, private store: Store) {}
}
